<template>
  <div>
    <Loader v-if="loading"/>
    <div v-else class="m-8">
      <div class="mb-4">
        <h2 class="text-3xl">{{ $lang.app.PROFILE }}</h2>
      </div>
      <div class="shadow shadow-indigo-600 rounded-md p-5 relative bg-white mb-6">
        <h2 class="text-blue-600 font-bold text-xl mb-3.5">
          {{ profileInfo.fullName }}
        </h2>
        <div class="flex">
          <Avatar :id="profileInfo.id" :photo="profileInfo.photo"/>
          <div class="w-full ml-5">
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.USERNAME }} :</div>
              <p class="w-1/4">{{ profileInfo.fullName }}</p>
            </div>
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.EMAIL }} :</div>
              <p class="w-1/4">{{ profileInfo.email }}</p>
            </div>
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.TYPE }} :</div>
              <p class="w-1/4">{{ $lang.app[userTypesGetLabelRefByValue(profileInfo.userInfo?.type)] }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="shadow shadow-indigo-600 p-5 rounded-md bg-white mb-6">
        <div class="overflow-x-auto overflow-y-auto">
          <div class="w-full py-8">
            <Contacts :profile="profileInfo" />
          </div>
        </div>
      </div>

      <div class="flex -mx-2">
        <template v-if="profileInfo.userInfo?.type === userTypesGetValue('INDIVIDUAL_ENTITY')">
          <Person :profile-id="profileInfo.id" :person="profileInfo.userInfo?.person"/>
          <PersonDocument :profile-id="profileInfo.id" :person-document="profileInfo.userInfo?.person?.personDocument"/>
        </template>
        <template v-if="profileInfo.userInfo?.type === userTypesGetValue('LEGAL_ENTITY')">
          <Organization :profile-id="profileInfo.id" :organization="profileInfo.userInfo?.organization"/>
        </template>
        <template v-if="profileInfo.userInfo?.type === userTypesGetValue('INDIVIDUAL_ENTREPRENEUR')">
          <IndividualEnterprise :profile-id="profileInfo.id" :individual-enterprise="profileInfo.userInfo?.individualEnterprise"/>
        </template>
        <BankDetail
            :profile-id="profileInfo.id"
            :user-type="profileInfo.userInfo?.type"
            :bank-detail="profileInfo.userInfo?.bankDetails"/>
        <ContactDetail
            :profile-id="profileInfo.id"
            :user-type="profileInfo.userInfo?.type"
            :contact-detail="profileInfo.userInfo?.contactDetail"/>
      </div>
    </div>
  </div>
</template>
<script>
import userApi from "../../../api/users";
import {
  getValueByKey as userTypesGetValue,
  getLabelRefByValue as userTypesGetLabelRefByValue
} from "../../../helpers/constants/userTypes";
import Person from "../../../components/applicant/profile/person/Index";
import Organization from "../../../components/applicant/profile/organization/Index";
import IndividualEnterprise from "../../../components/applicant/profile/individual-enterprise/Index";
import PersonDocument from "../../../components/applicant/profile/person-document/Index";
import BankDetail from "../../../components/applicant/profile/bank-detail/Index";
import ContactDetail from "../../../components/applicant/profile/contact-detail/Index";
import Avatar from "../../../components/applicant/profile/Avatar";
import Contacts from "@/components/employee/profile/Contacts";

export default {
  components: {
    Contacts,
    Person,
    Organization,
    IndividualEnterprise,
    PersonDocument,
    BankDetail,
    ContactDetail,
    Avatar,
  },
  data() {
    return {
      loading: false,
      profileInfo: null,
    }
  },
  created() {
    this.fetchProfileInfo()
  },
  methods: {
    userTypesGetValue,
    userTypesGetLabelRefByValue,
    fetchProfileInfo() {
      this.loading = true
      userApi.profile()
          .then(response => response.data.data)
          .then((res) => {
            this.profileInfo = res;
            this.$store.commit('setCurrentUser', res)
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
            this.loading = false
          });
    },
  },
  beforeMount() {
    this.$emitter.on('refresh-profile', () => {
      this.fetchProfileInfo()
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-profile')
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$emitter.emit('closeSidebar')
    })
  },
}
</script>